import { render, staticRenderFns } from "./AlbumItem.vue?vue&type=template&id=d2b496a2&scoped=true&"
import script from "./AlbumItem.vue?vue&type=script&lang=js&"
export * from "./AlbumItem.vue?vue&type=script&lang=js&"
import style0 from "./AlbumItem.vue?vue&type=style&index=0&id=d2b496a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b496a2",
  null
  
)

export default component.exports